@if (value !== null && value !== undefined && value !== '' && numericValue >= 0) {
<div class="sliding-scale-container" [ngClass]="'severity-' + getSeverityLevel()">
  <div class="slider-wrapper" [ngClass]="size">
    <div class="sliding-scale" 
         [style.background]="getSliderBackground()"
         [style.width]="customWidth">
      <div class="scale-marker" [style.left.%]="sliderPosition" [style.background-color]="getMarkerColor()" [style.border-color]="getMarkerColor()"></div>

      <div class="scale-value-positioned" [style.left.%]="sliderPosition">
        <span class="scale-number">{{ getDisplayValue() }}</span>
      </div>
    </div>
  </div>
</div>
} 